export default "__VITE_ASSET__698a91cb__"